import { NgModule } from '@angular/core';
import { RouterModule, type Routes } from '@angular/router';
import { LandingPageComponent } from './pages/landing-page/landing-page.component';
import { LandingPostResolver } from './landing-post.resolver';

export const routes: Routes = [
  {
    // path: '',
    // component: PostLandingLayoutComponent,
    // children:[
    //   {
    path: '',
    resolve: {
      postDetails: LandingPostResolver,
    },
    component: LandingPageComponent,
  },
  //   ]
  // }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PostLandingRoutingModule {}
